export function displayTrackName(track, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  let trackNameText = ''
  if (track.id && track.movement.work) {
    let workLangObj = track.movement.work.langs.find(langItem => langItem.locale === locale)
    if (!workLangObj && locale !== 'en-us') {
      workLangObj = track.movement.work.langs.find(langItem => langItem.locale === 'en-us')
    }
    if (!workLangObj && track.movement.work.langs.length > 0) {
      workLangObj = track.movement.work.langs[0]
    }
    if (workLangObj && workLangObj.name) {
      trackNameText = `${trackNameText} ${workLangObj.name}`
    }
  }
  if (track.id && track.movement) {
    let movementLangObj = track.movement.langs.find(langItem => langItem.locale === locale)
    if (!movementLangObj && locale !== 'en-us') {
      movementLangObj = track.movement.langs.find(langItem => langItem.locale === 'en-us')
    }
    if (!movementLangObj && track.movement.langs.length > 0) {
      movementLangObj = track.movement.langs[0]
    }
    if (movementLangObj && movementLangObj.name && trackNameText.trim() !== movementLangObj.name.trim()) {
      trackNameText = `${trackNameText} - ${movementLangObj.name}`
    }
  }
  return trackNameText
}

export function displayComposerName(composer, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (composer && composer.langs) {
    let matchedLangObj = composer.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = composer.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback to en-us if no current locale and no english
    if (!matchedLangObj && composer.langs.length > 0) {
      matchedLangObj = composer.langs[0] // still no locale data, get fisrt data in langs ary
    }
    // assemble compser's name
    if (matchedLangObj) {
      let nameText = matchedLangObj['last_name'] || ''
      if (matchedLangObj['first_name'] || matchedLangObj['middle_name']) {
        nameText += ', '
      }
      if (matchedLangObj['first_name']) {
        nameText += matchedLangObj['first_name']
      }
      if (matchedLangObj['middle_name']) {
        nameText += matchedLangObj['middle_name']
      }
      return nameText
    }
  }
  return '' // otherwise
}

export function displayComposerDescription(composer, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (composer && composer.langs) {
    const langsAry = composer.langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    return (matchedLangObj && matchedLangObj.description) || ''
  }
  return (composer && composer.description) || ''
}

export function displayComposerAliases(composer, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (composer && composer.langs) {
    let matchedLangObj = composer.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = composer.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback to en-us if no current locale and no english
    if (!matchedLangObj && composer.langs.length > 0) {
      matchedLangObj = composer.langs[0] // still no locale data, get fisrt data in langs ary
    }
    let matchedAliasObj = {}
    if (matchedLangObj && matchedLangObj.aliases) {
      matchedAliasObj = matchedLangObj.aliases.map(aliesItem => {
        if (aliesItem.locale === locale) {
          return aliesItem
        }
      })
    }
    // assemble compser's name
    if (Object.keys(matchedAliasObj).length) {
      let nameText = ''
      matchedAliasObj.forEach((alies, index) => {
        if (index < 10) {
          nameText += ' ' + alies['last_name'] || ''
          if (alies['first_name'] || alies['middle_name']) {
            nameText += ', '
          }
          if (alies['first_name']) {
            nameText += alies['first_name']
          }
          if (alies['middle_name']) {
            nameText += alies['middle_name']
          }
        }
      })
      return nameText
    }
    return ''
  }
  return '' // otherwise
}

export function displayPerformerName(performers, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (performers && performers.langs) {
    let matchedLangObj = performers.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = performers.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback if no current locale and no english
    if (!matchedLangObj && performers.langs.length > 0) {
      matchedLangObj = performers.langs[0]
    }
    // return matchedLangObj && matchedLangObj['last_name']
    if (matchedLangObj) {
      let nameText = matchedLangObj['last_name'] || ''
      if (matchedLangObj['first_name'] || matchedLangObj['middle_name']) {
        nameText += ', '
      }
      if (matchedLangObj['first_name']) {
        nameText += matchedLangObj['first_name']
      }
      if (matchedLangObj['middle_name']) {
        nameText += matchedLangObj['middle_name']
      }
      return nameText
    }
  }
  return '' // otherwise
}

export function displayPerformerPosition(performerPositon, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (performerPositon && performerPositon.langs) {
    let matchedLangObj = performerPositon.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = performerPositon.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback if no current locale and no english
    if (!matchedLangObj && performerPositon.langs.length > 0) {
      matchedLangObj = performerPositon.langs[0]
    }
    return matchedLangObj && matchedLangObj['name']
  }
  return ''
}
